import React, { Component } from 'react';
import ScrollableAnchor from 'react-scrollable-anchor';

import Divider from '../Divider/Divider';

// Style
import './FullMenuItem.css';

const FullMenuItem = (props) => {
  return (
    <ScrollableAnchor id={props.foodId}>
      <div className="full-menu-item">
        <div className="full-menu-item__wrapper">
          <div className={`${props.background} ${props.noImg ? "full-menu-item__bg-container_hide" : "full-menu-item__bg-container"}`} />
          <div className="full-menu-item__description">
            <div className="full-menu-item__header">
              <img alt="Chef Hat" className="full-menu-item__food-icon" src={props.foodIcon} />
              <h2>{props.foodName}</h2>
            </div>
            <Divider />
            <p>{props.description}</p>
          </div>
        </div>
      </div>
    </ScrollableAnchor>
  );
};

export default FullMenuItem;



// WEBPACK FOOTER //
// ./src/FullMenuItem/FullMenuItem.js